<!-- =========================================================================================
  File Name: BookEdit.vue
  Description: Book Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-book-meta-edit">

    <vs-alert color="danger" title="Book Meta Info Not Found" :active.sync="book_not_found">
      <span>Book record with id: {{ $route.params.bookSeq }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-book-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <!-- <vx-card v-if="book_data"> -->
    <vx-card title="교재 메타정보 수정" class="mb-base" v-if="bookMetaInfo">
      <book-meta-edit-form class="mt-4" :data="bookMetaInfo" />

    </vx-card>
  </div>
</template>

<script>
import BookMetaEditForm  from './BookMetaEditForm.vue'
import { fetchData } from '@/api/module'

export default {
  components: {
    BookMetaEditForm
  },
  data () {
    return {
      bookSeq: 0,
      bookMetaSeq: 0,
      bookMetaInfo: null,
      book_not_found: false
    }
  },
  methods: {
    async loadItem () {
      try {
        const { data } = await fetchData(`/book/${this.bookSeq}/meta/${this.bookMetaSeq}`)
        this.bookMetaInfo = data.data
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    } 
  },
  created () {
    this.bookSeq = this.$route.params.bookSeq
    this.bookMetaSeq = this.$route.params.bookMetaSeq
    this.loadItem()
  }
}

</script>
